import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';
import {SubscriptionCTA, SubscriptionCTAProps} from '@udemy/subscription-browse';
import {useConsumerSubscriptionValuePlan} from '@udemy/subscription-graphql';

import {PERSONAL_PLAN_UPGRADE_URL} from '../../constants';

/*Wrap SubscriptionCTA with Value Plan upgrade awareness
 *
 * if the current user is an active Value Plan (Starter Plan) subscriber
 * and is **not** already subscribed to the PP the component button pointa at the
 * tier upgrade checkout flow
 */
export const PersonalPlanSubscriptionCTA = (props: SubscriptionCTAProps) => {
    const {gettext} = useI18n();

    const valuePlanContext = useConsumerSubscriptionValuePlan();
    const isValuePlanSubscriber =
        valuePlanContext &&
        'isSubscriberToSpecificPlan' in valuePlanContext &&
        valuePlanContext.isSubscriberToSpecificPlan;

    const isPersonalPlanSubscriber =
        props.plan &&
        'isSubscriberToSpecificPlan' in props.plan &&
        props.plan.isSubscriberToSpecificPlan;

    if (isValuePlanSubscriber && !isPersonalPlanSubscriber) {
        return (
            <div className={props.className} data-purpose="subscription-cta">
                <Button
                    componentClass="a"
                    href={PERSONAL_PLAN_UPGRADE_URL}
                    size={props.size ?? 'large'}
                    udStyle="brand"
                >
                    {gettext('Upgrade your plan')}
                </Button>
            </div>
        );
    }

    return <SubscriptionCTA {...props} />;
};
